module.exports = __webpack_public_path__ + "img/ic_reddot.9b02304.webp";